import ClickTracking from '@/share/campaign/click-tracking-mixin'

export default {
  mixins: [ClickTracking],

  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelNameForAnalytics() {
      return 'WhatsApp'
    }
  },

  methods: {
    handleClick() {
      const shareClickToken = this.trackEvent()
      const url = this.urlWithShareClickToken(this.sharingOptions.href, shareClickToken)
      window.open(url)
    },

    urlWithShareClickToken(url, shareClickToken) {
      if (shareClickToken !== null) {
        // The original URL ends with a "text" parameter that includes some optional text followed by the
        // URL that the person is sharing. We want to edit that internal URL to add the "share" parameter to it.
        // The easiest way to do that, since we know it's at the end of the last parameter, is to just
        // stick the URL-encoded "&share=foo" on the end of the outer URL. When the "text" parameter is decoded,
        // this will result in the inner URL having the "share" parameter set.
        // This is kind of janky, but there aren't a lot of better options since the shared URL is within text
        // rather than separated into a parameter of its own.
        return url + encodeURIComponent(`&share=${shareClickToken}`)
      }
      return url
    }
  }
}
